import FetchUtils from '@dr-pam/common-components/Utils/FetchUtils';
import type { NdcAwardCompletion } from '@dr-pam/common-components/Models/NdcProgression';

const API_ROOT = '/api/ndc/progression/award-completion';

export function getNdcAwardCompletions(userId: string) {
	return FetchUtils.getJson<NdcAwardCompletion[]>(`${API_ROOT}/${encodeURIComponent(userId)}`);
}

export function setNdcAwardCompletion(userId: string, programmeId: string, completedOn: string | null) {
	return FetchUtils.putJson<NdcAwardCompletion[], { completedOn: string | null }>(
		`${API_ROOT}/${encodeURIComponent(userId)}/${encodeURIComponent(programmeId)}`,
		{ completedOn },
	);
}
